
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93gytG4OYSGTqTlkc8zSuiJLXY4WSKfSOCsFpXaW_Az98Meta } from "/codebuild/output/src1547660482/src/ark/pages/[...slug].vue?macro=true";
import { default as guiasAi_45rqZNQuBGhiOqhgLRbElA8sTh1ygETdgAQVQp2dQgMeta } from "/codebuild/output/src1547660482/src/ark/pages/blog/guias.vue?macro=true";
import { default as indexvOBOFxmc19_45JHs7YXf2qnM50824lEewoJtyuyEdOx_45kMeta } from "/codebuild/output/src1547660482/src/ark/pages/blog/index.vue?macro=true";
import { default as temash5c_tmkZB_uHXb_Mck7lFyGbbc3zeGTUszITdOXzt_45EMeta } from "/codebuild/output/src1547660482/src/ark/pages/blog/temas.vue?macro=true";
import { default as pesquisafz57jhqMqabfZiytbKlAt4HP9__45TeF4abu92KlNiF50Meta } from "/codebuild/output/src1547660482/src/ark/pages/blog/pesquisa.vue?macro=true";
import { default as moradaLV_tfK0FnHS72Jl_qpO_7GHHZVnjt1okl7DyArMRLYkMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue?macro=true";
import { default as habitantesdCMmJrQrINJ0qf9timoOeOL21mCCQ7v9U7Fohu3dbDYMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue?macro=true";
import { default as escalao_45gasl3m0TRut7LiICk5nuCfjfrB_Zi91NLnpMxcCXRnSBkUMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue?macro=true";
import { default as tempo_45em_45casam0YyBcEKvnVabWKpvYr_450TVD8bd0BBhA7DSDZZTXj4sMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue?macro=true";
import { default as tipo_45de_45produtopPyC3G2jtLOtCFPIL_45hkbRJu_455mTh836Y3EPN6feCDIMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue?macro=true";
import { default as comercializadoraMIpB397YcHuWCTLRs7uwk6Jp9rK9K76p9jWhMUzkO8sMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue?macro=true";
import { default as dados_45de_45contactoyN7xflTeEehiIjJ8G3lBdHlUO6mDBuRGdHHKzacaqtgMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue?macro=true";
import { default as potencia_45contratadas9dNb91TTAEaeKR16PqhZP2s7UGv5_stBRdXbHILxSAMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue?macro=true";
import { default as simular0Klml7uBDV_457FdNv9Pv6m4yld5zkgh_45lnE_zuDSx4acMeta } from "/codebuild/output/src1547660482/src/ark/pages/energia/simular.vue?macro=true";
import { default as internet_KZo_DWH0d0USfukv2eflACZln2rU8huhx5is89xjkMMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue?macro=true";
import { default as telemovelaTceDkv2rstVKJ2QMnenfbQuGoF9TZy0CcGZDQLOgZMMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue?macro=true";
import { default as fidelizacaoAHSfh5yaODss_PpsAMggDe54_45No5Hen9q8oVtNY1CeQMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue?macro=true";
import { default as operadora_45atualBMMaZ1l8fFVP2qy23Q9LRr5Go5Gsufjbi5ASRPluL8UMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue?macro=true";
import { default as dados_45de_45contactoANRN8MsNi_45_sEYKLwZRCHwOrYQrdGEeIJtjeo_ma_45_sMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue?macro=true";
import { default as simulardASgeXz1QAAUU5BWOZIim3Hxp1CJr2iByqwRTXTcjTYMeta } from "/codebuild/output/src1547660482/src/ark/pages/tv-net-voz/simular.vue?macro=true";
import { default as _91_46_46_46slug_93kXEv1gvjQpr8gTgxyropV93_45w_45qE4V7yaF36k5M_YOQMeta } from "/codebuild/output/src1547660482/src/ark/pages/blog/autor/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93I_45nNBIOoByrE67LvnZGzKIhtXRi_45z5SmZ1GxMX0Y1uEMeta } from "/codebuild/output/src1547660482/src/ark/pages/blog/rubricas/[...slug].vue?macro=true";
import { default as resumoXM7yC6nrUZwiLmeIK5jlNh6wSt62b4RrJAIBuwR08hkMeta } from "/codebuild/output/src1547660482/src/ark/pages/depositos-a-prazo/resumo.vue?macro=true";
import { default as finalidade_8Llb9Ywy8EJedIcXZxhF_45w_45R81XxbAoA3a82TQeR_45AMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue?macro=true";
import { default as tipo_45de_45taxat_45ZJwVmHvF0pJsqOPm5obEbKsjol4pkqwJwUEB_45jSZMMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue?macro=true";
import { default as dados_45de_45contactojHLCGShfgRELhwU8vHuRhmJIqCLK_45wTSGy6a9wu8e1cMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue?macro=true";
import { default as estado_45do_45processo9i1gRUk5PkX4b5vSh_YbS1okvJ3CfrfBKlyvv5m2xZMMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue?macro=true";
import { default as situacao_45financeiraG_45u3OeEhDrL_zryTWhrTBfPTgOJ0bn_LV3iSOjrDKrQMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue?macro=true";
import { default as montante_45do_45emprestimo75vKDGvkLE0rQI208DNQrUZcqqAJGXZD6wgWG1OAxNYMeta } from "/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue?macro=true";
import { default as simular1SwHZCZdjOwiwBimI8FAGvhibuHzERz1F0IouZvNsnIMeta } from "/codebuild/output/src1547660482/src/ark/pages/credito-habitacao/simular.vue?macro=true";
import { default as _91_46_46_46slug_93bkQtRNUco4ilqtoANTroE_45hbNpkLsz_HlgnxE5mJLpAMeta } from "/codebuild/output/src1547660482/src/ark/pages/simuladores/embed/[...slug].vue?macro=true";
import { default as resultadosGlSTnyjyaJ3Bq0iqMF1iFCSWYM5YkH5u727Ozz5ZTVUMeta } from "/codebuild/output/src1547660482/src/ark/pages/credito-habitacao/resultados.vue?macro=true";
import { default as index7vIKE7SnZyRFkGreCJXomZjTCaDD0i_45MVF9NKeFgiFQMeta } from "/codebuild/output/src1547660482/src/ark/pages/parcerias-imobiliarias/index.vue?macro=true";
import { default as _91_46_46_46slug_93GopS5FIe7jqgLQmigsIVELBj5XlBrmIw00aU7TPLbmgMeta } from "/codebuild/output/src1547660482/src/ark/pages/tv-net-voz/campanhas/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93_1Lf_o7ct1p5Prlz5i7LnAXHmpsRax4Y_mAuilB3CNcMeta } from "/codebuild/output/src1547660482/src/ark/pages/parcerias-imobiliarias/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/[...slug].vue")
  },
  {
    name: "blog-guias",
    path: "/blog/guias",
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/blog/guias.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/blog/index.vue")
  },
  {
    name: "blog-temas",
    path: "/blog/temas",
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/blog/temas.vue")
  },
  {
    name: "blog-pesquisa",
    path: "/blog/pesquisa",
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/blog/pesquisa.vue")
  },
  {
    name: "energia-simular",
    path: "/energia/simular",
    meta: { ...(simular0Klml7uBDV_457FdNv9Pv6m4yld5zkgh_45lnE_zuDSx4acMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/energia/simular.vue"),
    children: [
  {
    name: "energia-simular-morada",
    path: "morada",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue")
  },
  {
    name: "energia-simular-habitantes",
    path: "habitantes",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue")
  },
  {
    name: "energia-simular-escalao-gas",
    path: "escalao-gas",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue")
  },
  {
    name: "energia-simular-tempo-em-casa",
    path: "tempo-em-casa",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue")
  },
  {
    name: "energia-simular-tipo-de-produto",
    path: "tipo-de-produto",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue")
  },
  {
    name: "energia-simular-comercializadora",
    path: "comercializadora",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue")
  },
  {
    name: "energia-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue")
  },
  {
    name: "energia-simular-potencia-contratada",
    path: "potencia-contratada",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue")
  }
]
  },
  {
    name: "tv-net-voz-simular",
    path: "/tv-net-voz/simular",
    meta: { ...(simulardASgeXz1QAAUU5BWOZIim3Hxp1CJr2iByqwRTXTcjTYMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/tv-net-voz/simular.vue"),
    children: [
  {
    name: "tv-net-voz-simular-internet",
    path: "internet",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue")
  },
  {
    name: "tv-net-voz-simular-telemovel",
    path: "telemovel",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue")
  },
  {
    name: "tv-net-voz-simular-fidelizacao",
    path: "fidelizacao",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue")
  },
  {
    name: "tv-net-voz-simular-operadora-atual",
    path: "operadora-atual",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue")
  },
  {
    name: "tv-net-voz-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue")
  }
]
  },
  {
    name: "blog-autor-slug",
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/blog/autor/[...slug].vue")
  },
  {
    name: "blog-rubricas-slug",
    path: "/blog/rubricas/:slug(.*)*",
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/blog/rubricas/[...slug].vue")
  },
  {
    name: "depositos-a-prazo-resumo",
    path: "/depositos-a-prazo/resumo",
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/depositos-a-prazo/resumo.vue")
  },
  {
    name: "credito-habitacao-simular",
    path: "/credito-habitacao/simular",
    meta: { ...(simular1SwHZCZdjOwiwBimI8FAGvhibuHzERz1F0IouZvNsnIMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/credito-habitacao/simular.vue"),
    children: [
  {
    name: "credito-habitacao-simular-finalidade",
    path: "finalidade",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue")
  },
  {
    name: "credito-habitacao-simular-tipo-de-taxa",
    path: "tipo-de-taxa",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue")
  },
  {
    name: "credito-habitacao-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue")
  },
  {
    name: "credito-habitacao-simular-estado-do-processo",
    path: "estado-do-processo",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue")
  },
  {
    name: "credito-habitacao-simular-situacao-financeira",
    path: "situacao-financeira",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue")
  },
  {
    name: "credito-habitacao-simular-montante-do-emprestimo",
    path: "montante-do-emprestimo",
    component: () => import("/codebuild/output/src1547660482/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue")
  }
]
  },
  {
    name: "simuladores-embed-slug",
    path: "/simuladores/embed/:slug(.*)*",
    meta: _91_46_46_46slug_93bkQtRNUco4ilqtoANTroE_45hbNpkLsz_HlgnxE5mJLpAMeta || {},
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/simuladores/embed/[...slug].vue")
  },
  {
    name: "credito-habitacao-resultados",
    path: "/credito-habitacao/resultados",
    meta: resultadosGlSTnyjyaJ3Bq0iqMF1iFCSWYM5YkH5u727Ozz5ZTVUMeta || {},
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/credito-habitacao/resultados.vue")
  },
  {
    name: "parcerias-imobiliarias",
    path: "/parcerias-imobiliarias",
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/parcerias-imobiliarias/index.vue")
  },
  {
    name: "tv-net-voz-campanhas-slug",
    path: "/tv-net-voz/campanhas/:slug(.*)*",
    meta: _91_46_46_46slug_93GopS5FIe7jqgLQmigsIVELBj5XlBrmIw00aU7TPLbmgMeta || {},
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/tv-net-voz/campanhas/[...slug].vue")
  },
  {
    name: "parcerias-imobiliarias-slug",
    path: "/parcerias-imobiliarias/:slug(.*)*",
    meta: _91_46_46_46slug_93_1Lf_o7ct1p5Prlz5i7LnAXHmpsRax4Y_mAuilB3CNcMeta || {},
    component: () => import("/codebuild/output/src1547660482/src/ark/pages/parcerias-imobiliarias/[...slug].vue")
  }
]